import React, { useState } from 'react';

import { Button, Form } from 'react-bootstrap';

const OrderCommentsInfos = (_props: any) => {
  const [newComment, setNewComment] = useState('');

  return (
    <div>
      <div className="d-flex flex-column justify-content-between m-2 align-middle align-items-center gap-4 flex-wrap ">
        <Form className="w-100 d-flex flex-column justify-content-start">
          <Form.Group controlId="content">
            <Form.Control
              type="text"
              as="textarea"
              className="add-prop-textarea"
              placeholder="Laissez un commentaire ici..."
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              required
            />
          </Form.Group>
          <Button className="mt-2 mx-auto text-center mb-4 align-items-start " type="submit">
            Enregistrer
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default OrderCommentsInfos;
